// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"337c099e","70":"2b2a9df0","464":"ceb91d80","471":"5b62a417","659":"04d288b4","757":"533109da","949":"4fff8da1"}[chunkId] + ".chunk.js";
};